module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-hotlink",
    attrs: {
      "id": "section-hotlink",
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-offset": "-200"
    }
  }, [_c('div-container', [(_vm.items && _vm.items.length > 0) ? _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "column has-text-centered item-wrapper"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.route
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.image.path,
        "nopin": "nopin"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "banner-wrapper"
    }, [_c('div', {
      staticClass: "banner"
    }, [_c('span', [_vm._v(_vm._s(item.title))])])])])])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4e1b99e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HotlinkSection.vue
// module id = 942
// module chunks = 1